"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Score = void 0;
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _eventBusComponent2 = require("../../components/events/event-bus-component");
var CONFIG = _interopRequireWildcard(require("../../config"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
const ENEMY_SCORES = {
  ScoutEnemy: CONFIG.ENEMY_SCOUT_SCORE,
  FighterEnemy: CONFIG.ENEMY_FIGHTER_SCORE
};
var _score = /*#__PURE__*/new WeakMap();
var _eventBusComponent = /*#__PURE__*/new WeakMap();
class Score extends Phaser.GameObjects.Text {
  constructor(scene, eventBusComponent) {
    super(scene, scene.scale.width / 2, 20, '0', {
      fontSize: '24px',
      color: '#ff2f66'
    });
    _classPrivateFieldInitSpec(this, _score, void 0);
    _classPrivateFieldInitSpec(this, _eventBusComponent, void 0);
    this.scene.add.existing(this);
    _classPrivateFieldSet(_eventBusComponent, this, eventBusComponent);
    _classPrivateFieldSet(_score, this, 0);
    this.setOrigin(0.5);
    _classPrivateFieldGet(_eventBusComponent, this).on(_eventBusComponent2.CUSTOM_EVENTS.ENEMY_DESTROYED, enemy => {
      _classPrivateFieldSet(_score, this, _classPrivateFieldGet(_score, this) + ENEMY_SCORES[enemy.constructor.name]);
      this.setText(_classPrivateFieldGet(_score, this).toString(10));
    });
  }
}
exports.Score = Score;